import React, {useRef, useState} from "react";
import Style from './HoverDrop.module.less'
import classNames from "classnames";

let HoverDrop = (props) => {
    let {children, overlay, overlayWidth = 270, placement = 'left'} = props
    const [isShow, setIsShow] = useState(false)
    let Ref = useRef(null)
    let RefOverly = useRef(null)
    let styleRef = useRef({})
    let _show = () => {
        _setPosition()
        setIsShow(true)
    }
    let _hidden = () => {
        setIsShow(false)
    }
    let _setPosition = () => {
        let rect = Ref.current.getBoundingClientRect()
        let overlyRect = Ref.current.getBoundingClientRect()
        if (window.innerWidth - rect.right < overlayWidth + 10) {
            styleRef.current = {
                top: (rect.top - overlyRect.height / 2) + 'px',
                left: (rect.right - 270 - 20) + 'px'
            }
        } else {
            styleRef.current = {
                top: (rect.top - overlyRect.height / 2) + 'px',
                left: (rect.right + 10) + 'px'
            }
        }
    }
    let cloneEle = React.cloneElement(
        children,
        {
            // active: canTriggerActive ? shown : '',
            // onClick: trigger === 'click' ? () => {
            //     this._onTriggerEleClick();
            //     this.handleClick();
            // } : () => {
            //     this._onTriggerEleClick()
            // },
            ref: Ref,
            onMouseOver: _show,
            onMouseLeave: _hidden
            // style: {...children.props.style, display: active ? display : 'none'},
        }
    );

    return (
        <div>
            {cloneEle}
            <div ref={RefOverly} className={classNames(Style.overlay_box, {[Style.show]: isShow})}
                 style={styleRef.current}>
                {overlay}
            </div>
        </div>
    )
}
export default HoverDrop